import React from "react";
import SearchBar from "../../../components/SearchBar";
import useLocationSearch from "../hooks/useLocationSearch";

export default function LocationSearch({ map }) {
  const search = useLocationSearch(map);

  return (
    <div className="dc-location-search">
      <SearchBar
        value={search.query}
        onChange={search.setQuery}
        onSubmit={() => search.search()}
        isLoading={search.isSearching}
        placeholder="Search by location"
      />
      {search.suggestions.length > 0 && (
        <div className="dc-suggestions">
          {search.suggestions.map((suggestion) => (
            <button key={suggestion.place_id} type="button" onClick={() => search.selectSuggestion(suggestion)}>
              <strong>{suggestion.structured_formatting?.main_text}</strong>
              <span>{suggestion.structured_formatting?.secondary_text}</span>
            </button>
          ))}
        </div>
      )}
      {search.error && <div className="dc-search-error">{search.error}</div>}
    </div>
  );
}

